import { facilita } from '@/global'
import { api } from '@/Plugins/Axios'
import Service from '../../service'

/**
 * @type {Auth}
 */
export default class Auth extends Service {
    constructor(options = {}) {
        super(options)
        this.http = api
    }

    login(data) {
        return this.http.post('/authenticate', data)
    }

    loginOk(data) {
        return this.httpPanel.post('/ajaxloginok', data)
    }

    logout(token) {
        return this.httpPanel.get('/ajaxsair', {
            params: {
                vue_panel: true,
            },
            headers: {
                'goscore-token': facilita.gstoken,
                'goscore-token-user': token,
            },
        })
    }
}
